import { render, staticRenderFns } from "./IssuesCardWrapper.vue?vue&type=template&id=83de2c96&scoped=true&"
import script from "./IssuesCardWrapper.vue?vue&type=script&lang=ts&"
export * from "./IssuesCardWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./IssuesCardWrapper.vue?vue&type=style&index=0&id=83de2c96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83de2c96",
  null
  
)

export default component.exports